import {Box, Card, CardContent, Stack, Typography} from "@mui/material";
import Chart from "react-apexcharts";
import React, {useMemo, useState} from "react";
import {type PingResults, Servers} from "@/modules/trouble";

interface Props {
    pingResults: PingResults
}

export function PingTest({pingResults}:Props) {
    const [pickedServer, setPickedServer] = useState<Servers | null>();

    const seriesChart = useMemo(() => {
        if (!pickedServer) {
            return [{
                name: `Пинг`,
                data: []
            }];
        }
        return [{
            name: `Пинг на сервер ${pickedServer}`,
            data: pingResults[pickedServer].ping.map(result => result.pingTime)
        }];
    }, [pingResults, pickedServer]);

    const optionsChart: ApexCharts.ApexOptions = useMemo(() => {
        const options: ApexCharts.ApexOptions = {
            chart: {
                id: 'ping-chart',
                type: 'line',
                toolbar: {
                    show: false
                },
                animations: {
                    enabled: true,
                    speed: 800
                }
            },
            xaxis: {
                categories: [],
                title: {
                    text: 'Итерации'
                }
            },
            yaxis: {
                title: {
                    text: 'Пинг (ms)'
                }
            },
            stroke: {
                curve: 'smooth',
                width: 3
            },
            colors: ['#1976d2'],
            markers: {
                size: 5
            },
            tooltip: {
                enabled: true
            },
            grid: {
                borderColor: '#e0e0e0',
                row: {
                    colors: ['transparent', 'transparent'],
                    opacity: 0.5
                }
            },
        };

        if (pickedServer) {
            options.xaxis = {
                title: {
                    text: 'Итерации'
                },
                categories: pingResults[pickedServer].ping.map(result => result.iteration)
            };
        }

        return options;
    }, [pickedServer, pingResults]);

    const getAveragePing = () => {
        return Object.entries(pingResults).reduce((acc, [key, value]) => {
            const totalPingTime = value.ping.reduce((sum, ping) => sum + ping.pingTime, 0);
            return {
                ...acc,
                [key]: {
                    totalPingTime,
                    totalPings: value.ping.length
                },
            };
        }, {} as Record<Servers, {
            totalPingTime: number;
            totalPings: number;
        }>);
    };

    return (
        <Card>
            <CardContent>
                <Typography variant={'h6'}>
                    Нажмите на надпись для получения подробной информации
                </Typography>
                <Stack
                    gap={1}
                    sx={{
                        marginTop: 2
                    }}
                >
                    {Object.entries(getAveragePing()).map(([key, value]) => (
                        <Typography
                            sx={{
                                cursor: 'pointer',
                            }}
                            onClick={() => setPickedServer(key as Servers)}
                            key={key}
                        >
                            {`Сервер: ${key}, пинг ${value.totalPings !== 0 ? (value.totalPingTime / value.totalPings).toFixed(2) : 0}ms`}
                        </Typography>
                    ))}
                </Stack>
                {
                    pickedServer && (
                        <Box sx={{height: 300}}>
                            <Chart
                                type="line"
                                options={optionsChart}
                                series={seriesChart}
                                height="100%"
                            />
                        </Box>
                    )}
            </CardContent>
        </Card>
    );
}